import { Game } from '../game.model';
import { Player } from '../player.model';

export class Readied {
  game: Game;
  player: Player;
}
